export default __webpack_public_path__ + "static/media/tutorial-pre-cadastro-pagina1.156cb65b.svg";